import { Box, Container, Divider, Grid, List, ListItem, ListItemText, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router'
import { IRootState } from '../../../../../redux/types'
import { SectionTitle } from '../../../../shared/styles/HelpCenterStyles'
import useSectionData, { SectionData, SectionName } from '../hooks/useSectionData'
import ButtonBack from '@/contexts/shared/components/buttons/ButtonBack'

const Section = () => {
  const { t } = useTranslation(['helpcenter'])
  const navigate = useNavigate()
  const { type } = useParams<{ type: string }>()
  const [faq, setFaq] = useState<SectionName[]>([])
  const [objSections, setObjSections] = useState<string[]>([])
  const { user: authUser } = useSelector((state: IRootState) => state.auth)

  const handleInfo = (section: string, iQuestion: number) => {
    navigate(`/ayuda/tutoriales/${type}/${section}/${iQuestion}`)
  }

  const data: SectionData = useSectionData()

  useEffect(() => {
    if (authUser === null) return

    if (type === 'client') {
      setObjSections(['about-plei', 'profile', 'library', 'academy', 'events', 'basic'])
      setFaq(data.client)
    } else {
      setObjSections(['panel', 'clients', 'people', 'content', 'data', 'slider', 'brands'])
      if ([1, 2, 5].includes(authUser.role_id)) {
        setFaq(data.admin)
      } else {
        if ([3].includes(authUser.role_id)) {
          setFaq(data.responsible)
        } else {
          setFaq(data.comercial)
        }
      }
    }
  }, [type, authUser])

  return (
    <Container id="tutorials" sx={{ padding: 0, marginTop: 6.25 }} maxWidth="xl">
      <Container maxWidth="md">
        <Box>
          <ButtonBack />
        </Box>

        <Box mt={6} mb={1}>
          <SectionTitle variant="h4">{t('frequent-questions')}</SectionTitle>
          <Typography>{t('p1')}</Typography>
        </Box>

        <Box sx={{ display: 'grid', gap: 8 }}>
          <Grid container spacing={8}>
            {objSections.length > 0 &&
              faq
                .filter((sections: any, index) => sections[objSections[index]] !== undefined)
                .map((sections: any, index: number) => (
                  <Grid key={sections[objSections[index]].title} item xs={12} md={6}>
                    <Box pb={4} pt={4}>
                      <Typography variant="subtitle1">{sections[objSections[index]].title}</Typography>
                      <List component="nav">
                        {sections[objSections[index]].content.map((section: any, index2: number) => (
                          <Box key={`${objSections[index]}-item-${index2}`}>
                            <ListItem button onClick={() => handleInfo(objSections[index], index2)}>
                              <ListItemText primary={section.question} />
                            </ListItem>
                            <Divider />
                          </Box>
                        ))}
                      </List>
                    </Box>
                  </Grid>
                ))}
          </Grid>
        </Box>
      </Container>
    </Container>
  )
}

export default Section
